// extracted by mini-css-extract-plugin
export default {"hideTooltip":"y_-z","fadeIn":"z_-z","delay":"A_-z","recommendedSizeTooltip":"B_-z"};